export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    width: '60px',
  },
  {
    title: '模板名称',
    dataIndex: 'name',
    width: '200px',
  },
  {
    title: '使用场景',
    dataIndex: 'scene',
    width: '120px',
    customRender: (text, record, index)=>{
      return record.scene===1?'传统任务':'远程任务';
    },
  },
  {
    title: '调研目的',
    dataIndex: 'aim',
  },
  {
    title: '模板详情',
    dataIndex: 'jump_url',
    scopedSlots: { customRender: 'jump_url' },
    width: '100px',
  },
  {
    title: '关联产品',
    dataIndex: 'product_info_title',
    width: '150px',
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index)=>{
      return record.status===0?'禁用':'启用';
    },
    width: '60px',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: '150px',
  },
];
